import {autoRegister} from "../container";
import {noop} from "../common/utils/functions";
import {GLOBAL} from "../common/globals";

@autoRegister()
export class EopClipboard {

    public constructor(
        private clipboard: Clipboard = GLOBAL.navigator().clipboard
    ) {
    }

    public copy(value: string): void {
        this.clipboard.writeText(value).then(noop);
    }
}